import {
  AlertTriangle,
  Users,
  MessageSquare,
  GitBranch,
  Repeat,
  Network,
  Layers,
  Target,
  LucideIcon,
} from 'lucide-react'

export interface ConsequenceItem {
  icon: LucideIcon
  text: string
  sub: string
}

export interface CredibilityPair {
  left: string
  right: string
}

export interface RoleItem {
  icon: LucideIcon
  label: string
  humor: boolean
}

export const symptomsItems = [
  'Fler möten behövs bara för att synka',
  'Ansvar blir otydligt mellan team',
  'Beslut drar ut på tiden',
  'Samma frågor dyker upp igen och igen',
  'Chefen blir navet i nästan allt',
]

export const needsItems = [
  'Tydliga teamuppdrag och mandat',
  'Beslutsforum som faktiskt fungerar',
  'Struktur för tvärfunktionellt samarbete',
  'Visualisera beroenden mellan team',
  'Problemlösning där kompetensen finns',
]

export const consequences: ConsequenceItem[] = [
  {
    icon: MessageSquare,
    text: 'Möten om möten',
    sub: 'Synk tar tid som borde gå till leverans.',
  },
  {
    icon: AlertTriangle,
    text: 'Ansvar utan ägare',
    sub: 'Alla trodde någon annan hade koll.',
  },
  {
    icon: Repeat,
    text: 'Samma frågor – varje vecka',
    sub: 'Inget löses, allt återkommer.',
  },
  {
    icon: GitBranch,
    text: 'Team drar åt olika håll',
    sub: 'Utan gemensam riktning tappar ni fart.',
  },
  {
    icon: Network,
    text: 'Chefen är navet i allt',
    sub: 'Inget händer utan att det passerar dig.',
  },
  {
    icon: Layers,
    text: 'Ni växer i antal – inte i förmåga',
    sub: 'Fler team, men inte effektivare.',
  },
]

export const credibilityPairs: CredibilityPair[] = [
  { left: 'Informell samordning', right: 'Skalbar struktur' },
  { left: 'Alla vet allt', right: 'Rätt info till rätt person' },
  { left: 'Chefen beslutar', right: 'Beslut där kompetensen finns' },
  { left: 'Reaktiv problemlösning', right: 'Inbyggd samverkan' },
  { left: 'Växa i antal', right: 'Växa i förmåga' },
]

export const roles: RoleItem[] = [
  {
    icon: Target,
    label: 'Vi börjar i riktningen ni satte i Område 1',
    humor: false,
  },
  {
    icon: Layers,
    label: 'Vi designar teamens uppdrag, mandat och ansvar',
    humor: false,
  },
  {
    icon: GitBranch,
    label: 'Vi tydliggör beroenden och beslutsstrukturer',
    humor: false,
  },
  {
    icon: Network,
    label: 'Vi bygger synkstruktur som faktiskt håller',
    humor: false,
  },
  {
    icon: Users,
    label: 'Vi skapar cross-funktionella team kring verkliga problem',
    humor: false,
  },
  {
    icon: Repeat,
    label: 'Vi provar stegvis och justerar utifrån lärandet',
    humor: true,
  },
]

export const workPrinciples = [
  'Vi kartlägger era faktiska värdeströmmar – inte org-schemat',
  'Vi tydliggör vilka som behöver samverka när',
  'Vi bygger beslutsstrukturer som inte automatiskt landar hos chefen',
  'Vi säkerställer att rätt kompetenser kopplas ihop vid rätt tillfälle',
  'Vi arbetar iterativt – struktur som justeras, inte cementeras',
]

export const results = [
  'Strategi blir leverans',
  'Team får handlingskraft utan att vänta på chefen',
  'Problemlösning sker där kompetensen finns',
  'Beslut tas snabbare – och på rätt nivå',
  'Ni kan skala – stegvis och hållbart',
  '…och du slipper vara med på möten som egentligen inte behöver dig',
]

export const ctaPersonas = [
  {
    icon: Target,
    title: 'VD',
    text: 'Ni har växt men samordningen har inte hängt med.',
  },
  {
    icon: Users,
    title: 'Teamledare',
    text: 'Ditt team levererar — men samarbetet med andra team hackar.',
  },
  {
    icon: Layers,
    title: 'Chef',
    text: 'Du koordinerar mellan team men hinner inte leda ditt eget.',
  },
  {
    icon: Network,
    title: 'Ledningsgrupp',
    text: 'Ni vill skala — men strukturen bromsar.',
  },
]
